<span aria-hidden="true" [translate]="namespace + '.OLD_AGREEMENT_AMEX_NYSE_JOINT_PRE'"></span>
<a class="td-wb-padding--small td-wb-link td-wb-link--underlined"
   [attr.id]="'td-wb-agreement-old-link-NYSE'"
   [attr.aria-label]="(namespace+'.OLD_AGREEMENT_AMEX_NYSE_JOINT_PRE' | tdWbTranslate) + ' ' + (namespace+'.LINK_LABEL' | tdWbTranslate) + ' ' + (namespace+'.OLD_AGREEMENT_AMEX_NYSE_JOINT_POS' | tdWbTranslate)"
   tdWbHref="modal.preferences-agreements-old"
   [tdWbHrefParams]="{ agreementType: 'NYSE' }"
   [translate]="namespace+'.LINK_LABEL'"></a>
<span aria-hidden="true" [translate]="namespace+'.OLD_AGREEMENT_AMEX_NYSE_JOINT_POS'"></span>
